import { css } from '@emotion/css';
import React from 'react';
import { ReportForm, ReportFormProps } from './ReportForm';
import { ReportOverlayContainer } from './ReportOverlayContainer';

type ReportFormPageProps = ReportFormProps & {
  title: string;
  backButtonLabel: string;
};

export const ReportFormPage: React.FC<ReportFormPageProps> = ({
  title,
  backButtonLabel,
  onSubmit,
  isLoading
}) => {
  return (
    <ReportOverlayContainer title={title} backButtonLabel={backButtonLabel}>
      <div
        className={css`
          width: 100%;
          height: 100%;
          overflow-y: scroll;
        `}
      >
        <ReportForm onSubmit={onSubmit} isLoading={isLoading} />
      </div>
    </ReportOverlayContainer>
  );
};
